module.exports = __webpack_public_path__ + "static/media/empresa-01.1ad0ecdd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/empresa-01.jpg
// module id = 85
// module chunks = 0